import StitchFeaturePage from "../../components/sections/StitchFeaturePage";

const features = [
  { title: "Cloud Architecture", desc: "Infrastructure shaped for reliability, cost control, and operational sanity." },
  { title: "CI / CD", desc: "Faster, safer release workflows so shipping does not depend on heroics." },
  { title: "Containerisation", desc: "Docker-based packaging and environment consistency across development and production." },
  { title: "Monitoring", desc: "Logs, alerts, and service visibility to catch issues before they turn into outages." },
  { title: "Backups & Recovery", desc: "Practical resilience planning for databases, assets, and business-critical environments." },
  { title: "Security Hardening", desc: "Access control, secrets handling, and baseline protection across infrastructure layers." },
];

const CloudDevOps = () => (
  <StitchFeaturePage
    label="CLOUD & DEVOPS"
    title="Infrastructure that"
    titleAccent="stays stable."
    subtitle="Cloud setup, deployment workflows, and operational guardrails for teams that need dependable delivery."
    features={features}
    ctaLabel="PLAN YOUR CLOUD STACK"
  />
);

export default CloudDevOps;
